var sliceIntoChunks = function (arr, chunkSize) {
    if (chunkSize === void 0) { chunkSize = 3; }
    var res = [];
    for (var i = 0; i < arr.length; i += chunkSize) {
        var chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
};
var parseSkills = function (_a) {
    var skillIds = _a.skillIds, skills = _a.skills;
    return skillIds
        .map(function (id) { return skills.find(function (skill) { return skill.id === "skill" + id; }); })
        .filter(function (skill) { return skill !== undefined; });
};
var parseStandards = function (_a) {
    var standardIds = _a.standardIds, standards = _a.standards;
    return standardIds
        .map(function (id) { return standards.find(function (standard) { return standard.id === "standard" + id; }); })
        .filter(function (standard) { return standard !== undefined; });
};
var parseImgs = function (tasks) {
    var parsedImgs = [];
    ['easy', 'medium', 'challenging'].forEach(function (level) {
        var curLvlImgs = tasks.filter(function (img) { return img.level === level; });
        if (curLvlImgs.length) {
            var enImgs = curLvlImgs.filter(function (img) { return img.lang === 'en'; });
            var esImgs = curLvlImgs.filter(function (img) { return img.lang === 'es'; });
            parsedImgs.push({
                level: level,
                en: enImgs,
                es: esImgs,
            });
        }
    });
    return parsedImgs;
};
export var parsePrintables = function (_a) {
    var printables = _a.printables, domains = _a.domains, standards = _a.standards, skills = _a.skills, selectedSkillsAndStandards = _a.selectedSkillsAndStandards, unlockWith = _a.unlockWith;
    var parsedPrintables = [];
    var hasSelectedSkills = selectedSkillsAndStandards.length > 0;
    if (!printables.length)
        return parsedPrintables;
    if (hasSelectedSkills) {
        var filteredBySelectedSkillsAndStandards = printables.filter(function (_a) {
            var skillIds = _a.skillIds, standardIds = _a.standardIds;
            return selectedSkillsAndStandards.find(function (_a) {
                var id = _a.id, value = _a.value;
                var curId = id.replace(value.type, '');
                return value.type === 'skill'
                    ? skillIds.includes(Number(curId))
                    : standardIds.includes(Number(curId));
            });
        });
        if (filteredBySelectedSkillsAndStandards.length) {
            var transformedData = filteredBySelectedSkillsAndStandards.map(function (data) {
                var _a;
                var parsedSkills = parseSkills({ skillIds: data.skillIds, skills: skills });
                var parsedStandards = parseStandards({
                    standardIds: data.standardIds,
                    standards: standards,
                });
                var parsedImgs = parseImgs((_a = data.contents.tasks) !== null && _a !== void 0 ? _a : []);
                return {
                    id: data.id,
                    name: data.name,
                    preparationTime: data.preparationTime,
                    cooperative: data.cooperative,
                    skills: parsedSkills,
                    standards: parsedStandards,
                    contents: parsedImgs,
                    grade: data.gradeValue,
                    locked: data.locked,
                    availableToReview: data.availableToReview,
                };
            });
            var chunkedArray = sliceIntoChunks(transformedData);
            parsedPrintables.push({
                printables: chunkedArray,
            });
        }
    }
    else {
        domains.forEach(function (domain) {
            var filteredByDomain = printables.filter(function (_a) {
                var domainIds = _a.domainIds;
                return domainIds.includes(domain.id);
            });
            if (filteredByDomain.length) {
                var transformedData = filteredByDomain.map(function (data) {
                    var _a;
                    var parsedSkills = parseSkills({ skillIds: data.skillIds, skills: skills });
                    var parsedStandards = parseStandards({
                        standardIds: data.standardIds,
                        standards: standards,
                    });
                    var parsedImgs = parseImgs((_a = data.contents.tasks) !== null && _a !== void 0 ? _a : []);
                    return {
                        id: data.id,
                        name: data.name,
                        preparationTime: data.preparationTime,
                        cooperative: data.cooperative,
                        skills: parsedSkills,
                        standards: parsedStandards,
                        contents: parsedImgs,
                        grade: data.gradeValue,
                        locked: data.locked,
                        availableToReview: data.availableToReview,
                    };
                });
                if (unlockWith === 'unlocked')
                    transformedData.sort(function (printableA, printableB) {
                        var isAllSkillsFromCurrentDomainA = printableA.skills.every(function (skill) { return skill.value.domainId === domain.id; });
                        var isAllSkillsFromCurrentDomainB = printableB.skills.every(function (skill) { return skill.value.domainId === domain.id; });
                        if (isAllSkillsFromCurrentDomainA && !isAllSkillsFromCurrentDomainB)
                            return -1;
                        if (!isAllSkillsFromCurrentDomainA && isAllSkillsFromCurrentDomainB)
                            return 1;
                        return 0;
                    });
                var chunkedArray = sliceIntoChunks(transformedData);
                parsedPrintables.push({
                    domain: domain.name,
                    printables: chunkedArray,
                });
            }
        });
    }
    return parsedPrintables;
};
